import { isError } from 'app/utils/errors';

// HANDLER: Block
// Use CompleteRecord instead of ComposedEntityData to be able to get errors on BlockDataMap if it misses a block
const COMPOSED_ENTITY_DATA: CompleteRecord<Block, BlockDataWithErrorMap> = {
  'form-guide': null,
  'head-to-head': null,
  'players-stats': null,
  'players-head-to-head': null,
  'teams-stats': null,
  pool: null,
  rosters: null,
  stream: null,
  name: null,
  bracket: null,
  tournaments: null,
  'series-tournaments': null,
  'series-matches': null,
  'series-stats': null,
  'series-overview': null
};

const getInitialComposedEntityData = (): ComposedEntityData => ({
  ...COMPOSED_ENTITY_DATA
}); // return a copy

const getVideogameFromComposedData = (data: ComposedEntityData | undefined) =>
  data
    ? Object.values(data)
        .map(blockData => {
          if (blockData && !isError(blockData) && 'videogame_slug' in blockData) {
            const videogameSlug = blockData.videogame_slug;
            return videogameSlug;
          }
          return null;
        })
        .filter(Boolean)
        .at(0) || null
    : null;

const getSeriesIdFromComposedData = (data: ComposedEntityData | undefined) =>
  data
    ? Object.values(data)
        .map(blockData => {
          if (blockData && !isError(blockData) && 'serie_id' in blockData) {
            const seriesId = blockData.serie_id;
            return seriesId;
          }
          return null;
        })
        .filter(Boolean)
        .at(0) || null
    : null;

export { getInitialComposedEntityData, getVideogameFromComposedData, getSeriesIdFromComposedData };
